<template>
  <ul
    class="notification-list chat-message chat-message-field"
    :key="displayKey"
  >
    <div v-for="msg in messages" :key="msg.id" :data-cy="dataCy">
      <li
        class="pr-0"
        :class="{ right: user.id === msg.senderId }"
        v-if="msg.msg !== '\n'"
      >
        <div class="notification-event">
          <div v-if="msg.type !== 'FILE'" :class="[isChatPopup]">
            <span
              class="w-100 float-right text-break"
              :class="{
                receiver: user.id === msg.receiverId,
                sender: user.id === msg.senderId,
              }"
              v-if="msg.type === 'JOIN_PUBLIC_GROUP'"
              v-html="msg.msg"
              v-linkified
            ></span>
            <span
              v-else
              class="w-100 float-right text-break"
              :class="{
                receiver: user.id === msg.receiverId,
                sender: user.id === msg.senderId,
              }"
              v-linkified
            >
              {{ msg.msg }}
            </span>
            <span
              class="notification-date"
              :class="{ date: user.id === msg.senderId }"
            >
              <time class="entry-date updated" datetime="2004-07-24T18:18">{{
                msg.createdAt | relativeDate
              }}</time>
            </span>
          </div>
          <div v-if="msg.type === 'FILE'">
            <a
              class="w-100 float-right text-break"
              :class="{
                receiver: user.id === msg.receiverId,
                sender: user.id === msg.senderId,
              }"
              @click="getFile(msg.msg)"
              download
            >
              <span
                v-if="!msg.errno"
                class="d-block text-center file-hover"
                style="cursor: pointer"
                :class="{
                  receiver: user.id === msg.receiverId,
                  sender: user.id === msg.senderId,
                }"
              >
                <img :src="getChatImage(msg.msg)" id="chat-message" alt="Image" />
                <p>{{ msg.msg | fileName }}</p>
              </span>
              <span
                v-else
                class="d-block text-center file-hover text-danger"
                style="cursor: pointer"
                :class="{
                  receiver: user.id === msg.receiverId,
                  sender: user.id === msg.senderId,
                }"
                v-html="msg.msg"
                v-linkified
              ></span>
            </a>
            <span class="notification-date">
              <time class="entry-date updated" datetime="2004-07-24T18:18">{{
                msg.createdAt | date
              }}</time>
            </span>
          </div>
        </div>
      </li>
    </div>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import Vue from "vue";
import linkify from "vue-linkify";
Vue.directive("linkified", linkify);

export default {
  name: "MsgsChatDisplay",
  props: ["messages", "dataCy", "marginChatPopup", "receiver"],
  mixins: [ChatHelperVue],
  data() {
    return {
      displayKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    isChatPopup() {
      if (this.marginChatPopup) return "bigger-margin";
      return "";
    },
  },
  methods: {
    async getFile(file) {
      if (file) {
        if (!file.includes("Error")) {
          let fileName = file.substring(file.lastIndexOf("/") + 1);
          let blob = await this.fetchAttachment({ fileName: fileName });
          const fileURL = URL.createObjectURL(blob);

          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = fileURL;
          a.download = fileName;
          a.click();
          URL.revokeObjectURL(fileURL);
        }
      }
    },
  },
  filters: {
    date(date) {
      if (!date) return "";
      const dt = new Date(date);
      const f = (d) => (d < 10 ? "0" + d : d);
      return (
        f(dt.getMonth() + 1) + "/" + f(dt.getDate()) + "/" + dt.getFullYear()
      );
    },
    fileName(string) {
      if (string) {
        let fileName = string.substring(string.lastIndexOf("/") + 1);
        return fileName;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#chat-message {
  max-width: 100px;
  max-height: 100px;
}
.usr-img-thumb {
  height: 34px;
  width: 34px;
}
.right {
  text-align: right;
}
.sender {
  width: fit-content !important;
  background-color: #395693 !important;
  padding: 13px;
  margin-top: 0;
  border-radius: 10px;
  margin-bottom: 5px;
  font-size: 12px;
  fill: white;
  color: white;
}
.receiver {
  background-color: #939393;
  color: white;
  fill: white;
  padding: 13px;
  margin-top: 0;
  border-radius: 10px;
  margin-bottom: 5px;
  font-size: 12px;
}
.notification-event div {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 0.4rem;
  padding-left: unset;
}
.bigger-margin {
  margin-right: 1.4rem !important;
}
.file-hover {
  &:hover {
    color: blue;
  }
}
</style>
